module.exports = __webpack_public_path__ + "static/media/07.Foreign Tour.7bddd2d0.jpg";